/**
 * Identity of the native apps (T-080, ADR-0035). The application id is the Android package name,
 * the iOS bundle identifier and, as private-use URI scheme, the target of the OIDC redirect
 * (RFC 8252, section 7.1). Operators replace it with a reverse domain name they control before the
 * store release (T-083).
 */
export const nativeAppId = "de.zeitavo.app";

/** Path of the login callback inside the native URI scheme. */
export const nativeLoginCallbackPath = "/auth/callback";

/** Redirect URI of the login in the native apps. */
export const nativeRedirectUri = `${nativeAppId}:${nativeLoginCallbackPath}`;

/** Redirect URI after the logout in the native apps. */
export const nativePostLogoutRedirectUri = `${nativeAppId}:/`;
